import React from 'react'

const Footer = () => {
    return (
        <footer className='bg-light text-center fixed-bottom'>
            <p>&copy; 2023 <a href='https://wiltreasure.co.uk' >Wil Treasure</a></p>
        </footer>)
}

export default Footer